export const makeQueryStringFromObject = (data: Record<string, any>): string => {
  return Object.keys(data).reduce(
    (queryString, key) => (data?.[key] ? `${queryString}&${key}=${encodeURIComponent(data[key])}` : queryString),
    ''
  )
}
